import NewsletterForm from './NewsletterForm';
import React, { useState, useRef } from 'react';
import { graphql } from 'gatsby';

const ModularNewsletterForm = ({ data }) => {
  const { formHeading, legalTermsContent } = data;
  const [submitted, setSubmitted] = useState();
  return (
    <div className="modular-newsletter-form-container">
      <NewsletterForm
        formHeading={formHeading}
        legalTermsContent={legalTermsContent}
        backgroundColor="White"
        submitted={submitted}
        setSubmitted={setSubmitted}
      />
    </div>
  );
};
export default ModularNewsletterForm;
export const fragment = graphql`
  fragment ModularNewsletterForm on DatoCmsNewsletterForm {
    internal {
      type
    }
    formHeading {
      value
    }
    legalTermsContent {
      terms {
        slug
        title
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  }
`;
